import { z } from "zod";

export const queueSkipsSchema = z.object({
  hourly_skips_remaining: z.number(),
  daily_skips_remaining: z.number(),
});

export type QueueSkips = z.infer<typeof queueSkipsSchema>;
